module.exports = __webpack_public_path__ + "img/customerLogo12.3adbd611.png";